<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单列表
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">

        <el-form-item label="订单号">
          <el-input size="small" v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select size="small" v-model="searchForm.hotel_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in hotel" :key="index" :label="item.name" :value="item.hotel_id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="商家">
          <el-select size="small" v-model="searchForm.hotel_id" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="(item, index) in hotel" :key="index" :label="item.name" :value="item.hotel_id"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="searchForm.createTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item> -->
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item> -->
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="全部" name="all"></el-tab-pane>
          <el-tab-pane :label="'待接单'" name="payment">
            <span slot="label">待接单 ({{order_count.payment}})</span>
          </el-tab-pane>
          <el-tab-pane :label="'待出发'" name="delivery">
            <span slot="label">待出发 ({{order_count.delivery}})</span>
          </el-tab-pane>
          <el-tab-pane :label="'待收货'" name="received">
            <span slot="label">待收货 ({{order_count.received}})</span>
          </el-tab-pane>
          <el-tab-pane label="完成" name="complet">
            <span slot="label">完成 ({{order_count.cancel}})</span>
          </el-tab-pane>
        </el-tabs>
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="" label="订单号">
            <template slot-scope="scope">
              <div class="order-code">
                <div>订单ID：{{ scope.row.orderId }}</div>
                <div class="c_main">{{ scope.row.orderNo }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="技师信息">
            <template slot-scope="scope">
              <div>{{ scope.row.waiter.username }}
                <span class="gray9">ID：({{ scope.row.waiter.waiter_user_id }})</span>
              </div>
              <el-image :src='scope.row.waiter.avatarUrl' style="width:30px;height:30px"></el-image><br />
            </template>
          </el-table-column>
          <el-table-column prop="" label="服务信息">
            <template slot-scope="scope">
              <div class="product-info" v-for="(item, index) in scope.row.product" :key="index">
                <div class="pic"><img v-img-url="item.image.filePath" alt="" /></div>
                <div class="name gray3 product-name">
                  <span>{{ item.productName }}</span>
                  <span>{{ item.productPrice }}元</span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="" label="服务人员信息" min-width="100">
            <template slot-scope="scope" v-if="!scope.row.is_top_row && scope.row.waiter">
              <div style="display:flex">
                <img class="img" v-img-url="scope.row.waiter.avatarUrl" alt="" />
                <div class="name gray3 product-name">
                  <div>{{ scope.row.waiter.username }}(ID:{{ scope.row.waiter.waiter_user_id }})</div>
                  <div>{{ scope.row.waiter.mobile }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="matinfo" label="物料信息" width="150">
            <template slot-scope="scope">
              {{ scope.row.maproduct.productName }}<br />{{ scope.row.maproduct.productPrice }}<br />{{ scope.row.maproduct.total_num }}<br />
            </template>

          </el-table-column>
          <el-table-column prop="pay_price" label="实际支付" width="150">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间"> </el-table-column>
          <el-table-column prop="pay_type" label="支付类型" width="150">
          </el-table-column>
          <el-table-column prop="order_status_text" label="订单状态">
          </el-table-column>

          <el-table-column prop="pay_type.text" label="支付方式">
            <template slot-scope="scope" >
              <span class="gray9">{{ scope.row.pay_type.text }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="下单时间">
            <template slot-scope="scope" >
              {{ scope.row.createTime }}
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope" >
              <el-button @click="addClick(scope.row)" type="info" size="small" v-auth="'/order/order/detail'">详情</el-button>
            </template>

          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
    <Logistics :logisticsData="logisticsData" :isLogistics="isLogistics" @closeDialog='closeLogistics'></Logistics>
    <!-- <Recharge v-if="open_add" :open_add="open_add" :form="userModel" @closeDialog="closeDialogFunc($event, 'add')"></Recharge> -->
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import materialApi from "@/api/material.js";
import Logistics from "@/components/logistics/viewLogistics.vue";
// import Recharge from "./dialog/Recharge.vue";
import qs from "qs";
export default {
  components: {
    Logistics
    // Recharge
  },
  data() {
    return {
      /*切换菜单*/
      activeName: "all",
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        search: "",
        orderNo: "",
        style_id: "",
        createTime: ""
      },
      /*配送方式*/
      exStyle: [],
      hotel: [],
      /*门店列表*/
      shopList: [],
      /*时间*/
      createTime: "",
      /*统计*/
      order_count: {
        payment: 0,
        delivery: 0,
        received: 0
      },
      isLogistics: false,
      logisticsData: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {
    /*获取列表*/
    this.getmaterialOrder();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.getmaterialOrder();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getmaterialOrder();
    },

    /*切换菜单*/
    handleClick(tab, event) {
      let self = this;
      self.curPage = 1;
      self.getmaterialOrder();
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getmaterialOrder();
        }
      }
    },
    /*获取列表*/
    getmaterialOrder() {
      let self = this;
      let Params = this.searchForm;
      Params.dataType = self.activeName;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      self.loading = true;
      materialApi
        .materialOrder(Params, true)
        .then(res => {
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
          self.exStyle = res.data.ex_style;
          self.hotel = res.data.hotel;
          self.order_count = res.data.order_count.order_count;
          self.loading = false;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick(row) {
      let self = this;
      let params = row.orderId;
      self.$router.push({
        path: "/order/order/Detail",
        query: {
          orderId: params
        }
      });
    },
    cancelClick(row) {
      let self = this;
      let Params = {
        orderId: row.orderId,
        is_cancel: 1
      };
      self
        .$confirm("确定取消该订单?", "提示", {
          type: "warning"
        })
        .then(() => {
          OrderApi.confirm(Params, true).then(res => {
            self.$message({
              message: res.msg,
              type: "success"
            });
            self.getmaterialOrder();
          });
        });
    },
    getLogistics(row) {
      let self = this;
      let Params = {
        orderId: row.orderId
      };
      self.loading = true;
      OrderApi.queryLogistics(Params, true)
        .then(res => {
          self.logisticsData = res.data.express.list;
          self.loading = false;
          console.log(self.logisticsData);
          self.openLogistics();
        })
        .catch(error => {
          self.loading = false;
        });
    },
    openLogistics() {
      this.isLogistics = true;
    },
    closeLogistics() {
      this.isLogistics = false;
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getmaterialOrder();
    },
    onExport: function() {
      let baseUrl = window.location.protocol + "//" + window.location.host;
      window.location.href =
        baseUrl +
        "/index.php/shop/order.operate/export?" +
        qs.stringify(this.searchForm);
    }
  }
};
</script>
<style lang="scss">
.product-info {
  padding: 10px 0;
  border-top: 1px solid #eeeeee;
}
.order-code .state-text {
  padding: 2px 4px;
  border-radius: 4px;
  background: #808080;
  color: #ffffff;
}
.order-code .state-text-red {
  background: red;
}
.table-wrap .product-info:first-of-type {
  border-top: none;
}
.table-wrap .el-table__body tbody .el-table__row:nth-child(odd) {
  background: #f5f7fa;
}
</style>
<style lang="scss" scoped>
.img {
  width: 60px;
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/materials/order/index.1.vue